<sm-title-bar pageTitle="QR Codes"></sm-title-bar>

<div class="row g-4">
    <div class="col-md-6">
      <sm-un-used-qr></sm-un-used-qr>
    </div>
    <div class="col-md-6">
      <sm-linked-qr></sm-linked-qr>
    </div>
</div>